import Hero from "@/blocks/hero";

import {
  storyblokEditable,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";

export default function Page({ blok, entry }) {
  return (
    <main {...storyblokEditable(blok)}>
      <Hero blok={blok} entry={entry} />
      {blok.blocks?.map((blok) => (
        <StoryblokServerComponent blok={blok} key={blok._uid} />
      ))}
    </main>
  );
}
